import { Action, Store } from '@ngrx/store';
import { AppState } from './app.reducer';

interface IStoreService {
  dispatchLoad: (id?: any) => void;
}

export abstract class AppStoreService implements IStoreService {
  protected store: Store<AppState>;

  protected dispatchAction(action: Action) {
    this.store.dispatch(action);
  }

  abstract dispatchLoad(id?: any);
}
